const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useAutoplay } =
  window.BAO.Carousel.plugins

const highlightSecondSlide = (component, breakpoint = 901) => {
  return (slider) => {
    const update = () => {
      const details = slider.track?.details
      if (!details) return

      const length = slider.slides.length
      const activeIndex = details.rel
      const isDesktop = window.matchMedia(
        `(min-width: ${breakpoint}px)`,
      ).matches

      const highlightIndex = isDesktop
        ? (activeIndex + 1) % length
        : activeIndex % length

      slider.slides.forEach((slide, i) => {
        if (i === highlightIndex) {
          slide.setAttribute('active', '')

          if (component?.els?.name?.exists) {
            const name = slide.dataset.name || ''
            const container = component.els.name.element

            container.textContent = ''

            name.split(' ').forEach((word, index, arr) => {
              const span = document.createElement('span')
              span.className = 'sec-TeamCarousel_Part'
              span.textContent = word

              container.appendChild(span)

              if (index < arr.length - 1) {
                container.appendChild(document.createTextNode(' '))
              }
            })
          }
        } else {
          slide.removeAttribute('active')
        }
      })
    }

    slider.on('created', update)
    slider.on('slideChanged', update)
    slider.on('detailsChanged', update)
    slider.on('updated', update)
  }
}

class TeamCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onSlideClick = this.onSlideClick.bind(this)

    this.els.slide.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.onSlideClick)
    })
  }

  onSlideClick (e) {
    e.preventDefault()

    const slide = e.currentTarget
    const clickedIndex = parseInt(slide.dataset.slide)
    const isDesktop = window.BAO.MediaBreakpoints.isMd
    const length = this.carousel.slides.length

    if (slide.hasAttribute('active')) {
      const url = slide.dataset.url
      if (url) window.location.href = url
      return
    }

    const targetIndex = isDesktop
      ? (clickedIndex - 1 + length) % length
      : clickedIndex

    this.carousel.moveToIdx(targetIndex)
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          origin: 'center',
          perView: 'auto',
          spacing: 80,
        },
        breakpoints: {
          '(min-width: 451px)': {
            slides: {
              origin: 'center',
              perView: 'auto',
              spacing: 100,
            },
          },
          '(min-width: 901px)': {
            slides: {
              origin: 'auto',
              perView: 'auto',
              spacing: 100,
            },
          },
          '(min-width: 1440px)': {
            slides: {
              origin: 'auto',
              perView: 'auto',
              spacing: 134,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useAutoplay(this.cadence, { pauseOnHover: true }),
        highlightSecondSlide(this, 901),
      ],
    )
  }

  get cadence () {
    return this.dataset.cadence || 4
  }
}

if (!customElements.get('team-carousel')) {
  customElements.define('team-carousel', TeamCarousel)
}
